export default __webpack_public_path__ + "static/media/StaticPage3.0f254bfb.txt";